// funding_type_list_content

$(document).ready(() => {
    changeSelect();
    switchDuration()
    checkLoyer()
    checkDuree()
    assuranceCheck()
});


const changeSelect = () => {
    $('#funding_type_list').on('focus', () => {
        $('.homepage_funding_type select_wrapper').addClass('active')
    })
    $('#funding_type_list').on('focusout', () => {
        $('.homepage_funding_type select_wrapper').removeClass('active')
    })
}

const switchDuration = () => {
    $(document).on('change', ".switch input[type='radio']", (e) => {
        let value = $("input[name='periodicite']:checked").val()
        $('.duree-'+value).show().siblings('[class*="duree-"]').hide()
        let duree = $('.duree-'+value+' select').is("#duree-mensuel") ? "duree" : "duree2"
        $('.duree-'+value+' select').attr('name', duree)
        $('.duree-'+value).siblings('[class*="duree-"]').find('select').attr('name', 'hidden')
    })
}

const assuranceCheck = () => {
    $input = $('#simulateur-assurance label')
    $input.on('click', (e) => {
        $(e.currentTarget).parents('.checkbox_container').prev('table').find('span').toggleClass('selected')
    })
}

const checkLoyer = () => {
    let value = $("#loyer").val()

    $("#loyer").on('change', () => {
        value = $("#loyer").val()
        if(value == 90) {
            $('.mentions-loyer').show()
        } else {
            $('.mentions-loyer').hide()
        }
    })
}



const checkDuree = () => {
    $('.switch input[type="radio"]').on('change', () => {
        if($('input#annuel:checked').length) {
            $('select#loyer option[value="20"], select#loyer option[value="90"]').hide()
        } else {
            $('select#loyer option[value="20"], select#loyer option[value="90"]').show()
        }
    })

    $('select#loyer').on('change', (e) => {
        $('input#annuel').attr('disabled', $(e.currentTarget).val() != 0)
    })
}